export default "__VITE_ASSET__CvWszerG__"